import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchReportTemplates } from '../../predict/src/core/api/reporting/report-templates';
import { queryClient } from '../core/queryClient';

type FetchReportTemplatesResult = Awaited<ReturnType<typeof fetchReportTemplates>>;
type ReportTemplatesQueryOptions = Omit<QueryObserverOptions<FetchReportTemplatesResult>, 'queryKey' | 'queryFn'>;

export const reportTemplatesQueryKey = (organisationId: string, workspaceId: string, isConsolidation: boolean) => [
  'reportTemplates',
  organisationId,
  workspaceId,
  isConsolidation
];

export const reportTemplatesQuery = (
  workspaceId: string,
  organisationId: string,
  isConsolidation: boolean,
  options?: ReportTemplatesQueryOptions
): QueryObserver<FetchReportTemplatesResult> =>
  new QueryObserver<FetchReportTemplatesResult>(queryClient, {
    queryKey: reportTemplatesQueryKey(organisationId, workspaceId, isConsolidation),
    queryFn: () => fetchReportTemplates(workspaceId, organisationId, isConsolidation),
    ...options
  });
